import { Env } from '../app/models';
import bapiHosts from '../config/bapi-hosts.json';
import packageJson from '../../package.json';

export const environment = {
    production: true,
    name: Env.dev,
    apiUrl: bapiHosts.local,
    bapiEnv: 'qa',
    version: packageJson.version,
    analyticsEndpoint: ''
};
